import { ProtectedRouteProps } from "@mikros/library";
import { Navigate } from "react-router";

export function ProtectedRoute({ isAuthenticated, authenticationPath, outlet }: ProtectedRouteProps) {
    if (isAuthenticated) {
        return <div>
            {outlet}
        </div>
    } else {
        return <Navigate to={{ pathname: authenticationPath }} />;
    }
};
